import { Loadable } from 'loankeeper-common/components/hocs/LazyLoading'
import { createNavigationConfig } from 'loankeeper-common/components'

export const createOrderSearchNavigationItem = createNavigationConfig((translateFn) => ({
  icon: 'entries_all',
  text: translateFn('mnu_acc_entries'),
  identity: '/secure/order/search',
  permission: 'ACC_ENTRIES_VIEW',
}))

export default Loadable(() => import('./Components'))
